import Vue from 'vue'
import Router              from 'vue-router'
import Login               from './login'
import bo1                 from './backOffice1'
import bo2                 from './backOffice2'
import bo3                 from './backOffice3'


import fo1                  from './frontOffice1'
import fo2                  from './frontOffice2'
import fo3                  from './frontOffice3'
import fo4                  from './frontOffice4'
import fo5                  from './frontOffice5'

import store               from './../store';

import admin               from './admin'
import market              from './market'
import report1              from './report1'
import report2              from './report2'
import report3              from './report3'
import report4              from './report4'

Vue.use(Router)
const router = new Router({
  mode:'history',



  routes: [
    ...Login,
    ...bo1,
    ...bo2,
    ...bo3,
    ...fo1, 
    ...fo2,
    ...fo3,
    ...fo4,
    ...fo5,
    ...report1,  
    ...report2,
    ...report3,
    ...report4,
    
    ...admin,
    ...market,
    
  ],
  
})

router.beforeEach((to, from, next) => {
  const isLoggedIn = store.getters['isLoggedIn']
  //console.log(from)
  if (to.name !== 'Login' && !isLoggedIn) next({ name: 'Login' })
  else next()
})
export default router

